export class ValidationError extends Error {
  constructor(message: string = "Erro de validação") {
    super(message);
    this.name = "ValidationError";
  }
}

export class NotFoundError extends Error {
  constructor(message: string = "Não encontrado") {
    super(message);
    this.name = "NotFoundError";
  }
}

export class UnexpectedError extends Error {
  constructor(message: string = "Erro inesperado") {
    super(message);
    this.name = "UnexpectedError";
  }
}

export class InvalidUserOrPasswordError extends Error {
  constructor(message: string = "Usuário ou senha inválidos") {
    super(message);
    this.name = "InvalidUserOrPasswordError";
  }
}

export class IntegrationError extends Error {
  constructor(message: string = "Erro de integração") {
    super(message);
    this.name = "IntegrationError";
  }
}

export class AlreadyExistsError extends Error {
  constructor(message: string = "Entidade já existe") {
    super(message);
    this.name = "AlreadyExistsError";
  }
}

export class UnauthorizedError extends Error {
  constructor(message: string = "Usuário não autorizado") {
    super(message);
    this.name = "UnauthorizedError";
  }
}

export class NotAuthenticatedError extends Error {
  constructor(message: string = "Erro de autenticação") {
    super(message);
    this.name = "NotAuthenticatedError";
  }
}
